import React, { useMemo, useState } from "react";
import {
  ENDPOINTS,
  userAddRows,
  userHeader,
  userSearchKeys,
  userUpdateRows,
} from "../../helpers/constants";
import useAppChoices from "../../hooks/useAppChoices";
import EntityCRUD from "../EntityCRUD";
import { Button } from "react-bootstrap";
import { BookmarkCheck, Pen, PersonLinesFill } from "react-bootstrap-icons";
import AlertModal from "../AlertModal";

const Users = () => {
  const [markDefaultMeta, setMarkDefaultMeta] = useState(null);

  const crewAppChoices = useAppChoices("users")
    ?.filter(({ crew }) => crew)
    ?.map(({ crew }) => crew);

  const uniqueCrews = useMemo(() => {
    let appChoicesSet = new Set(crewAppChoices);

    return Array.from(appChoicesSet);
  }, []);

  const MarkDefaultButton = (user) => {
    return (
      <Button
        variant="outline-primary"
        className="px-1 py-0 mr-1"
        onClick={() => setMarkDefaultMeta({user})}
      >
        <PersonLinesFill size={10} />
      </Button>
    );
  };

  const onUpdateUserDefaultStatus = async ()=>{
    try {
      setMarkDefaultMeta({...markDefaultMeta,showProgress:true})
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <EntityCRUD
        entityAppChoiceKey="Users"
        entityName="Users"
        endpoint={ENDPOINTS.USERS_LIST}
        entityTableHeaders={userHeader(uniqueCrews)}
        entityTableSearchKeys={userSearchKeys}
        addFormRows={userAddRows(uniqueCrews)}
        updateFormRows={(user) =>
          typeof userUpdateRows === "function"
            ? userUpdateRows(user, uniqueCrews)
            : userUpdateRows
        }
        showDelete={false}
        createDetails={{
          endPoint: ENDPOINTS.CREATE_USER,
        }}
        updateDetails={{
          endPoint: ENDPOINTS.UPDATE_USER_DETAILS,
          method: "POST",
        }}
        // otherActions={MarkDefaultButton}
      />
      <AlertModal
        show={Boolean(markDefaultMeta)}
        onHide={() => setMarkDefaultMeta(null)}
        onDismissClick={() => setMarkDefaultMeta(null)}
        onContinueClick={onUpdateUserDefaultStatus}
        showProgress={markDefaultMeta?.showProgress}
        alertText={"Are you sure you want to mark this user as default?"}
      />
    </>
  );
};

export default Users;
